module.exports = __webpack_public_path__ + "media/educators/student-materials@2x-ae12b7c7.jpg";